import React from 'react'
import "./PlainTextContent.css"
import { useNavigate } from 'react-router-dom'

function PlainTextContent({
    heading="",
    content="",
    btnText="",
    btnRef="/",
    bgColor="white",
    fontThemeDark=false,
    btnClass="btn-dark"
}) {
     const paragraphs = content.split('\n').map((paragraph, index) => <p key={index} className={`body-paragraph my-1 mb-0 pb-3 ${!fontThemeDark && "color-light"}`}>{paragraph}</p>);
    const navigate = useNavigate()
  return (
    <div className='PlainTextContent-container standard-padding-space'
    style={{backgroundColor:`${bgColor}`}}
    >
        <div className='container'>
            <div className='text-start content-container'>
                <h3 className={`body-heading ${!fontThemeDark && "color-light"} `} >{heading}</h3>
                <div className={`body-paragrpah ${!fontThemeDark && "color-light"} mt-3`}>{paragraphs}</div>
                {btnText && <button className={`mt-3 genral-btn ${btnClass}`} onClick={()=>{navigate(btnRef)}}>{btnText}</button>}
            </div>
        </div>
    </div>
  )
}

export default PlainTextContent